// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import MultiImage from '../../../../elements/MultiImage/MultiImage';
import { FormattedMessage, intlShape } from 'react-intl';
import { stateConverter, purchaseThreeStateConverter } from '../../../order/utils/stateConverter';
import { getLocalizedCountry } from '../../../local-values/utils/countries';

import style from './OrderBox.scss';
import icons from '../../../../assets/styles/icons.scss';
import type { Order } from '../../../../entities';
import type {
  StateConvertResponse,
  PurchaseInnerThreeState,
} from '../../../order/utils/stateConverter';
import type { LocalValuesState } from '../../../local-values/duck';

type Props = {
  +localValues: LocalValuesState;
  +order: Order;
  +handleOpenModal?: (order: Order) => void;
};

export default class OrderBox extends Component<Props> {

  handleClick = (e: any) => {
    if (e.target.className.indexOf('deleteIcon') !== -1) {
      e.preventDefault();
    }
  };

  render() {
    const { order, handleOpenModal, localValues } = this.props;
    const stateResponse: StateConvertResponse = stateConverter(false, order.state);
    const purchaseStateResponse: PurchaseInnerThreeState = purchaseThreeStateConverter(order.state);
    const isActiveOrders = !!handleOpenModal;
    // console.log(!!(order.invoice && order.invoice.payment && order.invoice.payment.state === 'UNCONFIRMED'), order);
    let link = `/purchase/order/${order.id}`;
    // if (!!(order.invoice && order.invoice.payment && order.invoice.payment.state === 'UNCONFIRMED')) {
    if (order.invoice &&
      ((order.invoice.payment && order.invoice.payment.state === 'PENDING') || !order.invoice.payment)) {
      link = `/new-order/checkout/order/${order.id}`;
    }
    return (
      <Fragment>
        <Link to={link}
              onClick={this.handleClick}
              className={style.orderBox}>
          <article className={style.smallWrap}>
            <section className={style.top}>
              <section className={style.imageWrap}>
                <MultiImage items={order.items}/>
              </section>
              <section className={style.content}>
                <p className={style.id}>{order.id}</p>
                {order && order.invoice && order.invoice.payment &&
                <FormattedMessage id="orders.orderBox.content.total">{
                  text => <p className={style.total}>{`${text}: $${order.invoice.payment.total}`}</p>
                }</FormattedMessage>}
                {order.deliveryCountry &&
                <FormattedMessage id={stateResponse.labelIntlShort}>{
                  text => stateResponse.innerState === '3p' ?
                    (<p className={style.state}>
                      {`${text} ${getLocalizedCountry(order.deliveryCountry.code,
                        this.context.intl.formatMessage, localValues.countriesMap)}`}
                    </p>) :
                    (<p className={style.state}>{text}</p>)
                }</FormattedMessage>}
                {isActiveOrders && <section className={style.tracking}>
                  <div className={classNames(style.step,
                    { [style.active]: ['1p', '2p', '3p'].includes(purchaseStateResponse) })}/>
                  <div className={classNames(style.step, style.center,
                    { [style.active]: ['2p', '3p'].includes(purchaseStateResponse) })}/>
                  <div className={classNames(style.step,
                    { [style.active]: purchaseStateResponse === '3p' })}/>
                </section>}
              </section>
            </section>
            <section className={style.bottom}>
              {/*NOTE: Might need a new case for RESERVED and show options*/}
              {isActiveOrders && ['CREATED', 'AVAILABLE'].includes(order.state) ?
                <i onClick={() => order && handleOpenModal && handleOpenModal(order)}
                   className={classNames(icons.iconTrashcanMedium, style.delete, { deleteIcon: true })}/> : <div/>}
              <p><i
                className={classNames(icons.iconShoppingCartMedium, style.cart)}/> {order.items.length}
              </p>
            </section>
          </article>
          <article className={style.mediumWrap}>
            <section className={style.left}>
              <section className={style.imageWrap}>
                <MultiImage items={order.items}/>
              </section>
              <section className={style.content}>
                <p className={style.id}>{order.id}</p>
                {order && order.invoice && order.invoice.payment &&
                <FormattedMessage id="orders.orderBox.content.total">{
                  text => <p className={style.total}>{`${text}: $${order.invoice.payment.total}`}</p>
                }</FormattedMessage>}
                <p className={style.items}>
                  <i className={classNames(icons.iconShoppingCartMedium, style.cart)}/> {order.items.length}</p>
              </section>
            </section>
            <section className={classNames(style.right, { [style.orderPast]: !isActiveOrders })}>
              <section className={style.content}>
                {order.deliveryCountry &&
                <FormattedMessage id={stateResponse.labelIntlShort}>{
                  text => stateResponse.innerState === '3p' ?
                    (<p className={style.state}>
                      {`${text} ${getLocalizedCountry(order.deliveryCountry.code,
                        this.context.intl.formatMessage, localValues.countriesMap)}!`}
                    </p>) :
                    (<p className={style.state}>{text}</p>)
                }</FormattedMessage>}
                {isActiveOrders && <section className={style.tracking}>
                  <div className={classNames(style.step,
                    { [style.active]: ['1p', '2p', '3p'].includes(purchaseStateResponse) })}/>
                  <div className={classNames(style.step, style.center,
                    { [style.active]: ['2p', '3p'].includes(purchaseStateResponse) })}/>
                  <div className={classNames(style.step,
                    { [style.active]: purchaseStateResponse === '3p' })}/>
                </section>}
                {isActiveOrders && ['CREATED', 'AVAILABLE'].includes(order.state) &&
                <i onClick={() => order && handleOpenModal && handleOpenModal(order)}
                   className={classNames(icons.iconTrashcanMedium, style.delete, { deleteIcon: true })}/>}
              </section>
            </section>
          </article>
        </Link>
      </Fragment>);
  }
}

OrderBox.propTypes = {
  localValues: PropTypes.object.isRequired,
  order: PropTypes.object,
  handleOpenModal: PropTypes.func,
};

OrderBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderBox/OrderBox.jsx